export async function getRegistrationSummary($http, generalMeetingId) {
  const response = await $http.get(
    `/v2/gm/general-meetings/${generalMeetingId}/shareclass-registrations-summary`
  );
  return response.data;
}
